
export default function pxFromCm(cm: number): number {
  return Math.round(5 * 496 * cm / 21)
}
